/*****  Les modules  ******/

export const config = {
	id: 'config',
	text: 'Configuration',
	path: '/configuration',
};
export const enterprises = {
	id: 'societes',
	text: 'Sociétés',
	path: '/societes',
};

export const allModules = {
	id: 'modules',
	text: 'Modules',
	path: '/modules',
};

export const comptes = {
	id: 'comptes',
	text: 'Utilisateurs',
	path: '/comptes',
};

export const roles = {
	id: 'roles',
	text: 'Roles',
	path: '/roles',
};

export const sessions = {
	id: 'sessions',
	text: 'Sessions',
	path: '/sessions',
};

export const EmailsTemplates = {
	id: 'sessions',
	text: 'Modéles Emails',
	path: '/email/templates',
};

export const configuration = {
	text: 'Configuration',
	// config: config,
	// EmailsTemplates: EmailsTemplates,
	enterprises: enterprises,
	comptes: comptes,
	roles: roles,
	sessions: sessions,
	gestionModules: allModules,
	permissions: ['sup_admin'],
};

/********* Final modules **********/

export const modules = {
	// gestionComptes: gestionComptes,
	configuration: configuration,
};
